$(document).on('keydown', '.enter-submit', (e) => {
    if (e.which === 13) {
        $('.enter-submit').trigger('submit');
    }
})

$(document).on('keydown', '.enter-btn-submit', (e) => {
    if (e.which === 13) {
        $('.btn-submit').trigger('click');
    }
})


